import "./component.scss";



// WEBPACK FOOTER //
// ./app/components/card_module/component.js